import { alpha, Box, Chip, FormControl, InputLabel, LinearProgress, MenuItem, Paper, Select, TableCell, TableHead, TableRow, Typography, useTheme } from '@mui/material'
import React, { useState } from 'react'
import ProgramDashboardCard from './DashboardCard'
import { GoOrganization } from 'react-icons/go'
import { AccountBalanceOutlined, AttachMoneyOutlined, CalendarTodayOutlined, CalendarViewDayOutlined, CalendarViewWeekOutlined, CheckCircleOutline, CheckCircleOutlined, ChecklistOutlined, PeopleAltOutlined, PeopleOutlined, PersonOutlineOutlined, PlaylistAddCheckOutlined, SavingsOutlined, StarOutlined, TrendingUpOutlined, WarningAmberOutlined, WarningOutlined, WorkspacePremiumOutlined } from '@mui/icons-material'
import { ProgramCustomIcon, ProjectCustomIcon } from '../../styled/CustomIcons'
import { useApplicationContext } from '../../../context/ApplicationContext'
import { TableVirtuoso } from 'react-virtuoso'
import { TableComponents } from '../../common/previewTemplate/StaticComponents'
import { font } from '../../../styles/font'
import Badge from '../Badge'
import { amber, blue, deepOrange, green, indigo, orange, pink, purple, red, teal } from '@mui/material/colors'
import OrganisationDashboardCard from './DashboardCard'

const Schedule = {
    "On track": "🟡",
    "At risk": "🟢",
    "Off track": "🔴"
}

function DashboardContainer() {
    const { projectList } = useApplicationContext();

    const [selectedProject, setSelectedProject] = useState("")

    let dummyCardListMain = [
        {
            title: "Total Portfolio value",
            value: "$12.4M",
            count: "24",
            icon: <AccountBalanceOutlined sx={{ fontSize: "2rem", color: blue[600] }} />,
            subTitle: "Company allocation",
            subTitleDescription: "+5 this week",
            description: "+10% from last month",
        },
        {
            title: "Active Programs",
            value: "12",
            count: "25",
            icon: <PlaylistAddCheckOutlined sx={{ fontSize: "2rem", color: green[600] }} />,
            subTitle: "Currently assigned",
            subTitleDescription: "+5 this week",
            description: "+3 new the month",
        },
        {
            title: "Resource Utilisation",
            value: "87%",
            count: "20",
            icon: <PeopleOutlined sx={{ fontSize: "2rem", color: purple[500] }} />,
            subTitle: "Ready to assign",
            subTitleDescription: "+5 this week",
            description: "+5% optimal range",
        },
        {
            title: "ROI Achievement",
            value: "178%",
            count: "10",
            icon: <TrendingUpOutlined sx={{ fontSize: "2rem", color: teal[600] }} />,
            subTitle: "Within 30 days",
            subTitleDescription: "+5 this week",
            description: "Above target by 6%",
        },
    ];

    let dummyCardList = [
        {
            title: "Ahead",
            value: "8",
            count: "24",
            icon: <TrendingUpOutlined sx={{ fontSize: "2rem", color: green[600] }} />,
            subTitle: "Company allocation",
            subTitleDescription: "+5 this week",
        },
        {
            title: "On Track",
            value: "12",
            count: "25",
            icon: <CheckCircleOutlined sx={{ fontSize: "2rem", color: blue[600] }} />,
            subTitle: "Currently assigned",
            subTitleDescription: "+5 this week",
        },
        {
            title: "Under Budget",
            value: "5",
            count: "20",
            icon: <SavingsOutlined sx={{ fontSize: "2rem", color: teal[600] }} />,
            subTitle: "Ready to assign",
            subTitleDescription: "+5 this week",
        },
        {
            title: "At Risk",
            value: "7",
            count: "10",
            icon: <WarningOutlined sx={{ fontSize: "2rem", color: orange[600] }} />,
            subTitle: "Within 30 days",
            subTitleDescription: "+5 this week",
        },
        {
            title: "Over Utilised",
            value: "4",
            count: "10",
            icon: <PeopleOutlined sx={{ fontSize: "2rem", color: red[600] }} />,
            subTitle: "Within 30 days",
            subTitleDescription: "+5 this week",
        },
        {
            title: "Excellent",
            value: "2",
            count: "10",
            icon: <StarOutlined sx={{ fontSize: "2rem", color: amber[600] }} />,
            subTitle: "Within 30 days",
            subTitleDescription: "+5 this week",
        },
    ];

    return (
        <Box className="flex-1 flex flex-col gap-4">




            {/* main container */}
            <Box className="flex-1 flex flex-col gap-4 px-0 py-0">

                <Box className="grid grid-cols-4 gap-4 px-4 py-0 overflow-hidden ">

                    {
                        dummyCardListMain.map((item, index) => (
                            <OrganisationDashboardCard key={index} item={item} showDescription={true} />
                        ))
                    }
                </Box>


                <Box className="grid grid-cols-6 gap-4 px-4 py-0 overflow-hidden ">

                    {
                        dummyCardList.map((item, index) => (
                            <ProgramDashboardCard key={index} item={item} />
                        ))
                    }
                </Box>

                <Box className="flex-1 flex flex-col gap-4 px-4 py-4">
                    <Paper className="flex-1  flex flex-col gap-4 px-0 py-4" >

                        <Box className="flex items-center justify-between gap-2 px-4 py-0">
                            <Typography color="textPrimary" fontWeight={"bold"}>Programs</Typography>

                            <Chip label={`10`} />
                        </Box>


                        <Box className="w-full h-full flex flex-col gap-4 px-4 py-0 ">
                            <Table />
                        </Box>

                    </Paper>
                </Box>


                {false && <Box className="flex-1 flex flex-col gap-2">

                    <Box className="flex flex-col px-4">
                        <Typography fontSize={font.size.fs_4} color="textPrimary">Projects</Typography>
                    </Box>

                    <Box className="flex-1 flex flex-col px-4">
                        <Table />
                    </Box>

                </Box>}



            </Box>



        </Box>
    )
}

export default DashboardContainer


function Table() {
    const { handleOpenItemInNewWindow } = useApplicationContext();
    const theme = useTheme();

    const [openPermissionDialog, setOpenPermissionDialog] = useState(false);

    let LicenseType = {
        starter: "Starter",
        professional: "Professional",
        enterprise: "Enterprise",
    }

    let LicenseStatus = {
        renewed: "Renewed",
        upgraded: "Upgraded",
        active: "Active",
        inactive: "Inactive",
        expiredsoon: "Expired Soon",
        expired: "Expired",
    }

    let Priority = {
        high: "High",
        medium: "Medium",
        low: "Low",
    }



    const table_columns = [
        {
            data: "Name",
            dataKey: "name",
            padding: "none",
            px: "0.4rem",
            align: "left",
            background: theme.palette.header.main,

            sx: {
                minWidth: "180px",
                width: "100%",
                maxWidth: "auto",
                border: "0px solid #000"
            },
        },
        // {
        //     data: "Description",
        //     dataKey: "description",
        //     padding: "none",
        //     px: "0.4rem",
        //     align: "left",
        //     background: theme.palette.header.main,

        //     sx: {
        //         minWidth: "180px",
        //         width: "100%",
        //         maxWidth: "auto",
        //         border: "0px solid #000"
        //     },
        // },

        {
            data: "Priority",
            dataKey: "priority",
            padding: "none",
            px: "2rem",
            align: "center",
            background: theme.palette.header.main,

            sx: {
                minWidth: "180px",
                maxWidth: "180px",
                border: "0px solid #000"
            },
        },

        {
            data: "Status",
            dataKey: "status",
            padding: "none",
            px: "2rem",
            align: "center",
            background: theme.palette.header.main,

            sx: {
                minWidth: "180px",
                maxWidth: "180px",
                border: "0px solid #000"
            },
        },
        {
            data: "Progress",
            dataKey: "progress",
            padding: "none",
            px: "2rem",
            align: "center",
            background: theme.palette.header.main,

            sx: {
                minWidth: "200px",
                maxWidth: "200px",
                border: "0px solid #000"
            },
        },
        {
            data: "Budget",
            dataKey: "budget",
            padding: "none",
            px: "0.4rem",
            align: "center",
            background: theme.palette.header.main,

            sx: {
                minWidth: "120px",
                maxWidth: "120px",
                border: "0px solid #000"
            },
        },
        {
            data: "Timeline",
            dataKey: "timeline",
            padding: "none",
            px: "0.4rem",
            align: "center",
            background: theme.palette.header.main,

            sx: {
                minWidth: "120px",
                maxWidth: "120px",
                border: "0px solid #000"
            },
        },
        {
            data: "Lead",
            dataKey: "lead",
            padding: "none",
            px: "0.4rem",
            align: "center",
            background: theme.palette.header.main,

            sx: {
                minWidth: "120px",
                maxWidth: "120px",
                border: "0px solid #000"
            },
        },



    ];

    const dummyList = [
        {
            id: 1,
            name: "Amason E-commerce Platform",
            description: "Next-generation online retail platform with AI recommendations",
            schedule: "ahead",
            scope: "on-track",

            quality: "excellent",
            raid: "medium-risk",
            resource: "optimal",

            execution: "automation",
            verification: "verified",
            status: "Ahead",
            priority: "High",
            progress: 36,
            budget: "$3.5M",
            timeline: "Q4 2024",
            lead: "Adan Ronald",
            type: "Project",
        },
        {
            id: 2,
            name: "Cloud Migration Initiative",
            description: "Legacy system migration to AWS cloud infrastructure",
            schedule: "behind",
            scope: "increased",

            quality: "poor",
            raid: "high-risk",
            resource: "over-utilized",

            execution: "manual",
            verification: "unverified",
            status: "On Track",
            priority: "LOW",
            progress: 36,
            budget: "$3.5M",
            timeline: "Q4 2024",
            lead: "Adan Ronald",
            type: "Project",
        },
        {
            id: 3,
            name: "Mobile Banking App",
            description: "Cross-platform mobile banking application with biometric auth",
            schedule: "on-track",
            scope: "on-track",

            quality: "excellent",
            raid: "low-risk",
            resource: "optimal",

            execution: "automation",
            verification: "verified",
            status: "On Track",
            priority: "High",
            progress: 36,
            budget: "$3.5M",
            timeline: "Q4 2024",
            lead: "Adan Ronald",
            type: "Project",
        },
        {
            id: 4,
            name: "Data Analytics Dashboard",
            description: "Real-time business intelligence and analytics platform",
            schedule: "slightly-behind",
            scope: "on-track",

            quality: "good",
            raid: "medium-risk",
            resource: "optimal",

            execution: "automation",
            verification: "verified",
            status: "On Track",
            priority: "High",
            progress: 36,
            budget: "$3.5M",
            timeline: "Q4 2024",
            lead: "Adan Ronald",
            type: "Project",
        },
        {
            id: 5,
            name: "IoT Smart Factory",
            description: "Industrial IoT implementation for manufacturing automation",
            schedule: "ahead",
            scope: "increased",

            quality: "good",
            raid: "high-risk",
            resource: "optimal",

            execution: "manual",
            verification: "unverified",

            status: "Ahead",
            priority: "Medium",
            progress: 36,
            budget: "$3.5M",
            timeline: "Q4 2024",
            lead: "Adan Ronald",
            type: "Project",
        },

    ];

    const handleClick = (itemData) => {

    }


    const handleOpenItem = (e, item) => {
        console.log("item clicked")


        if (item?.name && item?.type) {
            console.log("clicked ctrl key +")
            handleOpenItemInNewWindow(item);
        } else {
        }

        return;

        // ctrl + mouse click
        if (e.ctrlKey && e.button === 0) {
            console.log("clicked ctrl key")

            if (item?.name && item?.type) {
                handleOpenItemInNewWindow(item);
            } else {

            }
        }
    }


    return (
        <Box className="flex-1 flex flex-col gap-4">


            <TableVirtuoso
                style={{ height: "100%", width: "100%", overflowX: 'auto', borderRadius: theme.shape.borderRadius, boxShadow: "none", border: `1px solid ${theme.palette.divider}` }}
                data={dummyList}
                components={TableComponents}
                fixedHeaderContent={() => (
                    <TableHead>
                        {
                            table_columns?.map((item, index, arr) => (
                                <TableCell
                                    key={index}
                                    align={item?.align}
                                    padding={item?.padding}
                                    className="whitespace-nowrap"
                                    sx={{
                                        py: 0.5,
                                        margin: "0 0rem !important",
                                        // background: item?.background,
                                        ...item?.sx,
                                        borderBottom: `1px solid ${theme.palette.divider}`,
                                        // background : alpha(theme.palette.secondary.main, 0.1),
                                        // zIndex : 10
                                    }}
                                >
                                    <Box className="py-1 flex items-center gap-2 min-w-full " sx={{ px: item?.px }}>
                                        <Typography className="flex-1 whitespace-nowrap" textAlign={item?.align} color="textPrimary" > {item?.data}</Typography>
                                    </Box>
                                </TableCell>
                            ))
                        }
                    </TableHead>
                )}


                itemContent={(itemIndex, itemData) => (
                    <TableRow className="cursor-pointer" onClick={() => handleClick(itemData)}>

                        {
                            table_columns?.map((item, index, arr) => {

                                console.log(itemData[item?.dataKey], itemData, item, "dataKey")
                                return (
                                    <TableCell padding={item?.padding} align={item?.align} sx={{ py: 1, cursor: item?.dataKey === "title" && "pointer", ...item?.sx, borderBottom: `0px solid ${theme.palette.divider}`, }}>
                                        {
                                            item?.dataKey === "index" ? (
                                                <Box className="flex items-center py-1 " sx={{ px: item?.px }}>
                                                    <Typography textAlign={item?.align} className="flex-1">{itemIndex + 1}.</Typography>
                                                </Box>
                                            ) : item?.dataKey === "name" ? (
                                                <Box className="flex items-center py-1 " sx={{ px: item?.px }}>
                                                    <Typography textAlign={item?.align} fontWeight={"bold"} className="flex-1 hover:underline" onClick={(e) => handleOpenItem(e, itemData)}>{itemData[item?.dataKey]}</Typography>
                                                </Box>
                                            ) : (item?.dataKey === "priority" || item?.dataKey === "status") ? (
                                                <Box className="flex items-center py-1 overflow-hidden" sx={{ px: item?.px }}>
                                                    <Badge text={itemData[item?.dataKey]} />
                                                </Box>
                                            ) : (item?.dataKey === "progress") ? (
                                                <Box className="flex items-center justify-center gap-1 py-1 overflow-hidden" sx={{ px: item?.px }}>

                                                    <Box className="flex-1 flex items-center  gap-1 overflow-hidden">
                                                        <LinearProgress variant="determinate" value={itemData[item?.dataKey]} size={12} thickness={6} sx={{ width: "100%", borderRadius: 1 }} />
                                                    </Box>

                                                    <Typography textAlign={item?.align} className="">{itemData[item?.dataKey]}%</Typography>
                                                </Box>
                                            ) : (item?.dataKey === "timeline") ? (
                                                <Box className="flex items-center justify-center gap-1 py-1 overflow-hidden" sx={{ px: item?.px }}>
                                                    <Typography textAlign={item?.align} className="flex-1">{itemData[item?.dataKey] ? itemData[item?.dataKey] : "-"}</Typography>
                                                </Box>
                                            ) : (item?.dataKey === "budget") ? (
                                                <Box className="flex items-center justify-center gap-1 py-1 overflow-hidden" sx={{ px: item?.px }}>
                                                    <Typography textAlign={item?.align} fontWeight={"bold"} className="flex-1">{itemData[item?.dataKey] ? itemData[item?.dataKey] : "-"}</Typography>
                                                </Box>
                                            ) : (item?.dataKey === "action") ? (
                                                <Box className="flex items-center py-1 " sx={{ px: item?.px }}>
                                                    {/* <Button color="info">Edit</Button> */}
                                                    {/* <Button color="error" onClick={() => { return; setOpenPermissionDialog(true) }}>Revoke</Button> */}

                                                </Box>
                                            )
                                                : (
                                                    <Box className="flex items-center  py-1  " sx={{ px: item?.px }}>
                                                        <Typography textAlign={item?.align} className="flex-1">{itemData[item?.dataKey] ? itemData[item?.dataKey] : "-"}</Typography>
                                                    </Box>
                                                )
                                        }
                                    </TableCell>
                                )
                            })
                        }

                    </TableRow>

                )}
            />





        </Box>
    )
}